import { defineAction, object, string } from '~/prix'
import any from '~/prix/types/any'
import insightReadAction from './insightRead.action.json' assert { type: 'json' }

const insightReadDefinition = defineAction({
  ...insightReadAction,
  input: object({
    id: string(),
  }),
  output: object({
    insight: any(),
  }),
  cache: () => {
    return {
      front: {
        // 5 days
        expirationMsForFallback: 1000 * 60 * 60 * 24 * 5,
        // 5 minutes
        expirationMsForUpdate: 1000 * 60 * 5,
      },
    }
  },
})

export default insightReadDefinition
